/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meta_Showcase_Reviews_DescriptionInputs */

const en_meta_showcase_reviews_description = /** @type {(inputs: Meta_Showcase_Reviews_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aggregate guest reviews from Booking.com, Airbnb and direct stays into one filterable panel on your own site. Live demo of the reviews module.`)
};

const lv_meta_showcase_reviews_description = /** @type {(inputs: Meta_Showcase_Reviews_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apkopojiet viesu atsauksmes no Booking.com, Airbnb un tiešajām rezervācijām vienā filtrējamā skatā savā mājaslapā. Interaktīva atsauksmju moduļa demonstrācija.`)
};

/**
* | output |
* | --- |
* | "Aggregate guest reviews from Booking.com, Airbnb and direct stays into one filterable panel on your own site. Live demo of the reviews module." |
*
* @param {Meta_Showcase_Reviews_DescriptionInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const meta_showcase_reviews_description = /** @type {((inputs?: Meta_Showcase_Reviews_DescriptionInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meta_Showcase_Reviews_DescriptionInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_meta_showcase_reviews_description(inputs)
	return en_meta_showcase_reviews_description(inputs)
});